export default __webpack_public_path__ + "static/media/cold.b65607a0.jpg";